import React, { useEffect, useState } from "react";

//img
import profileImg from "../../../assets/images/png/Profile.png";
import btnImg from "../../../assets/images/svg/Search.svg";
import totalPOIMg from "../../../assets/images/svg/Total PO Value.svg";
import totalPOIMg2 from "../../../assets/images/svg/Total PO Value Copy 3.svg";
import totalPOIMg3 from "../../../assets/images/svg/Total PO Value Copy 2.svg";

//compnents
import DateBar from "../../../components/common/DateBar/DateBar";
import NotificationBell from "../../../components/common/NotificationBell/NotificationBell";
import ProfileCard from "../../../components/common/ProfileCard/ProfileCard";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";

//css
import classes from "../../TabStyles/DashboardTab.module.css";

//components
import DSelectInput from "../../../components/Dashboard/DashboardInputs/DSelectInput";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import DDateInput from "../../../components/Dashboard/DashboardInputs/DDateInput";
import DataTable from "../../../components/common/DataTable/DataTableSorting";
import PaginationComponent from "../../../components/common/Pagination/PaginationComponent";
import { nextPageClick, previouPageClick } from "../../../utils/pagination";
import SearchBar from "../../../components/common/SearchBar/SearchBar";

//redux toolkit
import { useSelector } from "react-redux/es/hooks/useSelector";
//charts and metics
import Reportcard from "../../../components/Dashboard/ReportCards/ReportCard";
import DonutChart from "../../../components/Dashboard/Charts/DonutChart/DonutChart";
import LineChart from "../../../components/Dashboard/Charts/LineChart/LineChart";
import BarChart from "../../../components/Dashboard/Charts/BarChart/BarChart";
import HorizontalBarChart from "../../../components/Dashboard/Charts/BarChart/HorizontalBarChart";
import { API_ENDPOINT } from "../../../services/api/resources";
import axios from "axios";
import { emptyCheck } from "../../../utils/validations";
import { ContactsOutlined } from "@mui/icons-material";
import { weeklyReportObjFormate } from "../../../utils/chartKeyFormat";
import GstFilingTable from "./GstFilingTable";
import MerchantInvoiceDelay from "./MerchantInvoiceDelay";



const BuyerDashboardTab = () => {
  //get data from use selector
  const data = useSelector((state) => state.loginData.value);

  //credentials
  const [auth_token, setAuthToken] = useState(data?.auth_token);
  const [buyer_token, setBuyerToken] = useState(data?.user?.token);
  const [org_token, setOrgToken] = useState(data?.user?.token);
  const [loadingState, setLoadingState] = useState(false);

  //unique user
  const [uniqueData, setUniqueData] = useState();
  const [uniqueLocalData, setUniqueLocalData] = useState();
  const [uniqueDataID, setUniqueDataID] = useState("");


  //  filter search
  const [searchQuery, setSearchQuery] = useState("");
  const [sortingColumnName, setSortingColumnName] = useState(null);

  const [sortingOrder, setSortingOrder] = useState(null);
  const order =
    sortingOrder === null || sortingOrder === "asc" ? "desc" : "asc";

  //pagination data
  const [paginationData, setPaginationData] = useState();
  const Datas = useSelector((state) => state.loginData.value);

  //pagination logics
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = paginationData?.current_page_count;
  const totalItems = paginationData?.page_count;



  const vendorContactRole = uniqueLocalData?.role !== "vendor contact";
  const [tableProps, setTableProps] = useState({
    isLoading: false,
    errorMessage: "",
  });
  const [pageNumber, setPageNumber] = useState(1);

  const [spendItems, setSpendItems] = useState([]);

  // input data
  const [vendorList, setVendorsList] = useState({
    values: {
      tokens: [],
      visibleOption: [],
    },
  });

  const [vendorDetails, setVendorDetails] = useState({
    vendorName: "",
    vendorID: "",
  });
  const [itemList, setItemList] = useState({
    values: {
      tokens: [],
      visibleOption: [],
    },
  });
  const [vendorNameDetails, setVendorNameDetails] = useState({
    buyerName: "",
    buyerID: "",
  });
  const [vendornameList, setVendornameList] = useState({
    values: {
      tokens: [],
      visibleOption: [],
    },
  })
  const [itemCode, setItemCode] = useState({
    item_code: "",
    item_token: "",
  });
  const [duration, setDuration] = useState();
  const [fromDate, setFromDate] = useState({
    value: "",
    isValid: true,
  });
  const [toDate, setToDate] = useState({
    value: "",
    isValid: true,
  });

  const [analyticsData, setAnalyticsData] = useState({
    totalPOValue: "",
    costSavingsMetric1: "",
    costSavingsMetric2: "",
    repeatPurchaseCostSavings: "",
    pendingVsCloseRFQ: [],
    openCancelPending: [],
    poTotal: "",
    submittedVsSelectedRFQ: [],
    totalRFQCreatedValueMonthWise: [],
    totalRFQCreatedLabelMonthWise: [],
    totalRFQCreatedValueWeekWise: [],
    totalRFQCreatedLabelWeekWise: [],
    totalPurchaseOrdersValueMonthWise: [],
    totalPurchaseOrdersLabelMonthWise: [],
    totalPurchaseOrdersValueWeekWise: [],
    totalPurchaseOrdersLabelWeekWise: [],
    totalSpentByItems: {
      labels: [],
      values: [],
    },
    vendorResponseTime: {
      labels: [],
      values: {
        minTime: [],
        maxTime: [],
      },
    },
    approverResponseTime: {
      labels: [],
      values: {
        minTime: [],
        maxTime: [],
      },
    },

    purchaseOrderStatus: [],
  });

  const [RFQCreationOption, setRFQCreationOption] = useState('monthly')
  const [totalPOOption, setTotalPOOption] = useState('monthly')

  // total spend table heading
  const headings = [
    { label: "Supplier Name", field: "supplier_name" },
    { label: "Geography", field: "geography" },
    { label: "Purchase Type", field: "purchase_type" },
    { label: "Purchase Category", field: "category" },
    { label: "SKU or Part Number", field: "part_number" },
    { label: "Item Code", field: "item_code" },
    { label: "Item Name", field: "item_name" },
    { label: "Item Description", field: "description" },
    { label: "Unit Price", field: "unit_price" },
    { label: "Total Price", field: "total_price" },
    { label: "PO Date", field: "purchase_order_date" },
    { label: "Supplier Invoice date", field: "supplier_invoice_date" },
  ];

  const getAnalyticsValues = async () => {
    const formData = new FormData();
    let filters = {};
    if (vendorNameDetails.buyerID && vendorNameDetails.buyerID.length !== 0) {
      formData.append("vendor_token", vendorNameDetails.buyerID);
      filters["vendor_token"] = vendorNameDetails.buyerID;
    } else if (vendorDetails.vendorID && vendorDetails.vendorID.length !== 0) {
      formData.append("company_token", vendorDetails.vendorID);
      filters["company_token"] = vendorDetails.vendorID;
    }

    if (data.access_type === "User") {
      formData.append("user_token", buyer_token);
      formData.append("buyer_token", buyer_token);
      filters["user_token"] = buyer_token;
      filters["buyer_token"] = buyer_token;
    } else {
      formData.append("buyer_token", buyer_token);
      filters["buyer_token"] = buyer_token;
    }

    if (
      itemCode.item_token &&
      itemCode.item_token !== "" &&
      itemCode.item_token !== null &&
      itemCode.item_token.length !== 0
    ) {
      formData.append("item_token", itemCode.item_token);
      filters["item_token"] = itemCode.item_token;
    }

    if (duration) {
      formData.append("month_period", duration);
      filters["month_period"] = duration;
    } else {
      if (fromDate.value) {
        formData.append("from_date", fromDate.value);
        filters["from_date"] = fromDate.value;
      }
      if (toDate.value) {
        formData.append("to_date", toDate.value);
        filters["to_date"] = toDate.value;
      }
    }


    setLoadingState(true);

    await axios({
      method: "POST",
      url: `${API_ENDPOINT.new_buyer_dashbord}`,
      data: formData,
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        setLoadingState(false);
        let responseData = res?.data;
        setAnalyticsData({
          totalPOValue: responseData && responseData["total po value"],
          poTotal: responseData && responseData["po total"],
          costSavingsMetric1:
            responseData && responseData["first cost saving metric 1"],
          costSavingsMetric2:
            responseData && responseData["first cost saving metric 2"],
          repeatPurchaseCostSavings:
            responseData && responseData["repeat purchase cost saving"],
          pendingVsCloseRFQ:
            responseData &&
            Object.values(responseData["pending vs closed rfq"]),
          submittedVsSelectedRFQ:
            responseData &&
            Object.values(responseData["submitted vs selected rfq"]),
          purchaseOrderStatus:
            responseData &&
            Object.values(responseData["po status"]),
          openCancelPending:
            responseData &&
            Object.values(responseData["po data"]),
          totalRFQCreatedValueMonthWise:
            responseData && Object.values(responseData["rfq monthly count"]).reverse(),
          totalRFQCreatedLabelMonthWise:
            responseData && Object.keys(responseData["rfq monthly count"]),
          totalRFQCreatedValueWeekWise:
            responseData && Object.values(weeklyReportObjFormate(responseData["rfq weekly count"])),
          totalRFQCreatedLabelWeekWise:
            responseData && Object.keys(weeklyReportObjFormate(responseData["rfq weekly count"])),
          totalPurchaseOrdersValueMonthWise:
            responseData && Object.values(responseData["po value monthwise"]).reverse(),
          totalPurchaseOrdersLabelMonthWise:
            responseData && Object.keys(responseData["po value monthwise"]),
          totalPurchaseOrdersValueWeekWise:
            responseData && Object.values(weeklyReportObjFormate(responseData["po weekly count"])),
          totalPurchaseOrdersLabelWeekWise:
            responseData && Object.keys(weeklyReportObjFormate(responseData["po weekly count"])),
          totalSpentByItems: {
            labels: responseData && Object.keys(responseData["item_spent"]),
            values: responseData && Object.values(responseData["item_spent"]),
          },
          vendorResponseTime: {
            labels:
              responseData &&
              Object.keys(responseData["vendor_response_report"]),
            values: {
              maxTime: [
                responseData &&
                Object.values(responseData["vendor_response_report"])?.map(
                  (e) => e?.max_response_time_hours
                ),
              ],

              minTime: [
                responseData &&
                Object.values(responseData["vendor_response_report"])?.map(
                  (e) => e?.min_response_time_hours
                ),
              ],
            },
          },
          approverResponseTime: {
            labels:
              responseData &&
              Object.keys(responseData["approval_response_report"]),
            values: {
              maxTime: [
                responseData &&
                Object.values(responseData["approval_response_report"])?.map(
                  (e) => e?.response_time_hours
                ),
              ],
              minTime: [
                responseData &&
                Object.values(responseData["approval_response_report"])?.map(
                  (e) => e?.response_time_minutes
                ),
              ],
            },
          },
        });

        getAllSpendItems(filters)

      })
      .catch((err) => {
        setLoadingState(false);
        console.log(err);
      });
  };

  const validateFilters = () => {
    const isfromDate = emptyCheck(fromDate?.value);

    const isToDate = emptyCheck(toDate?.value);

    setFromDate((prev) => ({ ...prev, isValid: isfromDate }));
    setToDate((prev) => ({ ...prev, isValid: isToDate }));

    return isfromDate && isToDate;
  };

  const handleFilterSearch = () => {
    let validateForm = !duration ? validateFilters() : true;
    if (validateForm) {
      getAnalyticsValues();
    } else {
      setFromDate((prev) => ({ ...prev, isValid: prev.isValid }));
      setToDate((prev) => ({ ...prev, isValid: prev.isValid }));
    }
  };

  useEffect(() => {
    getAllVendorsData();
    getAllItems();
    getAllSpendItems();
    getAnalyticsValues();
  }, []);

  let delay = 300;
  useEffect(() => {
    let timeoutId = null;
    timeoutId = setTimeout(() => {
      if (pageNumber) {
        getAllSpendItems();
      }
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [pageNumber, searchQuery, sortingColumnName, sortingOrder]);



  // total spend item
  const getAllSpendItems = async (filters = null) => {

    let payload = {
      buyer_token: org_token,
      page: pageNumber,
    };


    if (sortingColumnName && sortingColumnName.trim() !== "") {
      payload.sorting_column_name = sortingColumnName.trim();
      payload.sorting_order = order;
    }

    if (searchQuery && searchQuery.trim() !== "") {
      payload.search = searchQuery.trim();
    }

    if (filters && Object.keys(filters).length > 0) {
      payload = { ...payload, ...filters };
    }


    await axios({
      method: "POST",
      url: `${API_ENDPOINT.spend_item_view}`,
      data: payload,
      headers: {
        Authorization: `Bearer ${auth_token} `,
      },
    })
      .then((res) => {
        console.log(res)
        const { total_count, page_count, current_page_count } = res.data;
        const totalItems = total_count;
        const currentPage = pageNumber || 1;
        setSpendItems(res?.data?.records);
        setPaginationData({
          currentPage,
          totalItems,
          current_page_count,
          page_count,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //getAll vendor names
  const getAllVendorsData = async () => {
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.get_all_vendor}`,
      data: {
        org_token: buyer_token,
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        let uniqueDatas;
        if (Array.isArray(res?.data?.users)) {
          const uniqueValue = Array.from(new Set(res?.data?.users.map(item => item.company_name))).map(
            companyName => res?.data?.users.find(item => item.company_name === companyName)
          );
          uniqueDatas = uniqueValue;
        } else {
          console.error("The 'bidsData' is not an array or is undefined.");
          uniqueDatas = []; // Set a default value or handle it accordingly based on your use case
        }

        let vendor_list_shallow = new Set(
          res?.data?.users?.map((e) => {
            return e?.company_name + "";
          })
        );
        setVendorsList({
          values: {
            tokens: uniqueDatas.map((e) => {
              return e?.token;
            }),
            visibleOption: [...vendor_list_shallow],
          },
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const resetSearch = () => {
    // reset customer data
    setVendorNameDetails({
      buyerName: "",
      buyerID: "",
    })
    setVendornameList({
      values: {
        tokens: [null],
        visibleOption: ["No options"],
      },
    });
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(() => {
        document.getElementById('vendorName').value = ''
      }, 200);
    });
  }
  const getvendorName = async (companyToken) => {
    resetSearch()
    if (!companyToken || companyToken.length === 0) return
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.vendor_company_list}`,
      data: {
        buyer_token: buyer_token,
        vendor_token: companyToken,
      },
      headers: {
        Authorization: `Bearer ${auth_token} `,
      },
    })
      .then((response) => {
        resetSearch()
        let customerList = response.data.response;
        let uniqueDatas;
        if (Array.isArray(customerList)) {
          const uniqueValue = Array.from(new Set(customerList.map(item => item.full_name))).map(
            companyName => customerList.find(item => item.full_name === companyName)
          );
          uniqueDatas = uniqueValue;
        } else {
          console.error("The 'bidsData' is not an array or is undefined.");
          uniqueDatas = []; // Set a default value or handle it accordingly based on your use case
        }

        let customer_list_shallow = new Set(
          customerList?.map((e) => {
            return e?.full_name + "";
          })
        );
        setVendornameList({
          values: {
            tokens: uniqueDatas.map((e) => {
              return e?.token;
            }),
            visibleOption: [...customer_list_shallow],
          },
        })
      })
      .catch((error) => {
        console.log(error)
        setVendornameList({
          values: {
            tokens: [null],
            visibleOption: ["No options"],
          },
        });
      })
  }

  const durationList = ["last month", "last 3 months", "last 6 months"];

  const getAllItems = async () => {
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.view_all_item}`,
      data: {
        org_token: org_token,
      },
      headers: {
        Authorization: `Bearer ${auth_token} `,
      },
    })
      .then((res) => {
        setItemList({
          values: {
            tokens: res?.data?.response?.map((e) => {
              return e?.token;
            }),
            visibleOption: res?.data?.response?.map((e) => {
              return `${e?.item_name} - (${e?.item_code})`;
            }),
          },
        });
      })
      .catch((err) => {
        console.log(err);
        setItemList({
          values: {
            tokens: [null],
            visibleOption: ["No options"],
          },
        });
      });
  };

  let tempData = [
    Math.random() * 100,
    Math.random() * 100,
    Math.random() * 100,
    Math.random() * 100,
    Math.random() * 100,
    Math.random() * 100,
    Math.random() * 100,
    Math.random() * 100,
    Math.random() * 100,
    Math.random() * 100,
  ];
  const RFQCreatedDataValues = RFQCreationOption === "monthly" ? analyticsData?.totalRFQCreatedValueMonthWise : analyticsData?.totalRFQCreatedValueWeekWise; //check if month wise report
  const RFQCreatedDataLabel = RFQCreationOption === "monthly" ? analyticsData?.totalRFQCreatedLabelMonthWise : analyticsData?.totalRFQCreatedLabelWeekWise; //check if month wise report

  const RFQCreatedDataSets = {
    cardHeading: "Total RFQ Created",
    chartLabels: ["RFQ Created"],
    chartIndicators: [
      {
        value: "RFQ Created",
        color: "#6977F3",
      },
    ],
    barColor: ["#6977F3"],
  };

  const submittedAndSelectedDataValue =
    analyticsData?.submittedVsSelectedRFQ || [0, 0];
  let rfqTotal = submittedAndSelectedDataValue[1] + submittedAndSelectedDataValue[2] + submittedAndSelectedDataValue[3];
  const submittedAndSelectedDataSets = {
    cardHeading: "Submitted and Selected RFQ",
    chartText: (
      <span>
        Total RFQ <br />{" "}
        {rfqTotal}
        {/* {analyticsData?.submittedVsSelectedRFQ?.length > 1 &&
          analyticsData?.submittedVsSelectedRFQ?.reduce((a, b) => a + b)} */}
      </span>
    ),
    chartLabels: ["Submitted RFQ", "Selected RFQ", "Unselected RFQ", "Unsubmitted RFQ"],
    barColors: ["#B4D6C5", "#B4D8F2", "#EBF4F5", "#EEF4D5"],
    chartIndicators: [
      {
        value: "Submitted",
        color: "#B4D6C5",
      },
      {
        value: "Selected",
        color: "#B4D8F2",
      },
      {
        value: "Unselected",
        color: "#EBF4F5",
      },
      {
        value: "Unsubmitted",
        color: "#EEF4D5",
      },
    ],
    progressLines: [
      {
        label: `Submitted RFQ - ${submittedAndSelectedDataValue[0] || 0}`,
        color: "#B4D6C5",
        value: submittedAndSelectedDataValue[0],
      },
      {
        label: `Selected RFQ - ${submittedAndSelectedDataValue[1] || 0}`,
        color: "#B4D8F2",
        value: submittedAndSelectedDataValue[1] || 0,
      },
      {
        label: `Unselected RFQ - ${submittedAndSelectedDataValue[2] || 0}`,
        color: "#EBF4F5",
        value: submittedAndSelectedDataValue[2] || 0,
      },
      {
        label: `Unsubmitted RFQ - ${submittedAndSelectedDataValue[3] || 0}`,
        color: "#EEF4D5",
        value: submittedAndSelectedDataValue[3] || 0,
      },
    ],
  };

  const openCancelPendingDataValue = analyticsData?.openCancelPending || [0, 0, 0];

  const openCancelPendingDataSets = {
    cardHeading: "Open and Cancel PO",
    chartText: (
      <span>
        Total PO <br />{" "}
        {openCancelPendingDataValue[0] + openCancelPendingDataValue[1] + openCancelPendingDataValue[2] + openCancelPendingDataValue[3]}
      </span>
    ),
    chartLabels: ["Cancel PO", "Pending PO", "Open PO", "Closed PO"],
    barColors: ["#4ac6b7", "#4f5e7f", "#965f8a", "#ff7070"],
    chartIndicators: [
      {
        value: "Cancel",
        color: "#4ac6b7",
      },
      {
        value: "Pending",
        color: "#4f5e7f",
      },
      {
        value: "Open",
        color: "#965f8a",
      },
      {
        value: "Closed",
        color: "#ff7070",
      },
    ],
    progressLines: [
      {
        label: `Cancel PO - ${openCancelPendingDataValue[0] || 0}`,
        color: "#4ac6b7",
        value: openCancelPendingDataValue[0] || 0,
      },
      {
        label: `Pending PO - ${openCancelPendingDataValue[1] || 0}`,
        color: "#4f5e7f",
        value: openCancelPendingDataValue[1] || 0,
      },
      {
        label: `Open PO - ${openCancelPendingDataValue[2] || 0}`,
        color: "#965f8a",
        value: openCancelPendingDataValue[2] || 0,
      },
      {
        label: `Closed PO - ${openCancelPendingDataValue[3] || 0}`,
        color: "#ff7070",
        value: openCancelPendingDataValue[3] || 0,
      },
    ],
  };




  const totalPODataValues = totalPOOption === "monthly" ? analyticsData?.totalPurchaseOrdersValueMonthWise : analyticsData?.totalPurchaseOrdersValueWeekWise;
  const totalPODataValuesLabel = totalPOOption === "monthly" ? analyticsData?.totalPurchaseOrdersLabelMonthWise : analyticsData?.totalPurchaseOrdersLabelWeekWise;

  const totalPODataSets = {
    cardHeading: "Total Purchase Orders",
    chartLabels: ["Purchase Order"],
    chartIndicators: [
      {
        value: "Purchase Orders",
        color: "#EF737F",
      },
    ],
    barColor: ["#EF737F"],
  };

  const totalSpentDataValue = analyticsData?.totalSpentByItems;
  const totalSpentDataSetDataSets = {
    cardHeading: "Total Spend By Items",
    chartLabels: ["Submitted RFQ", "Selected RFQ"],
    barColors: ["#BF86BD"],
    chartIndicators: [
      {
        value: "Total Spend",
        color: "#BF86BD",
      },
    ],
  };

  const vendorResponseTimeDataSet = {
    chartData: [
      {
        label: "Average Response Time",
        backgroundColor: "#F8E4AC",
        barPercentage: 0.98,
        data: analyticsData?.vendorResponseTime?.values?.maxTime[0],
      },
      {
        label: "Minimum Response Time",
        backgroundColor: "#6199B3",
        barPercentage: 0.98,
        data: analyticsData?.vendorResponseTime?.values?.minTime[0],
      },
    ],
    chartYAxisLabels: analyticsData?.vendorResponseTime?.labels,
    cardHeading: "Vendor Response Time",
    chartLabels: ["Average Response Time", "Minimum Response Time"],
    barColors: ["#F8E4AC", "#6199B3"],
    chartIndicators: [
      {
        value: "Average Response Time (ART)",
        color: "#F8E4AC",
      },
      {
        value: "Minimum Response Time (MRT)",
        color: "#6199B3",
      },
    ],
  };

  const approverResponseTimeDataSet = {
    chartData: [
      {
        label: "Response Time In Hours",
        backgroundColor: "#F8E4AC",
        barPercentage: 0.98,
        data: analyticsData?.approverResponseTime?.values?.maxTime[0],
      },
      {
        label: "Response Time In Minutes",
        backgroundColor: "#6199B3",
        barPercentage: 0.98,
        data: analyticsData?.approverResponseTime?.values?.minTime[0],
      },
    ],
    chartYAxisLabels: analyticsData?.approverResponseTime?.labels.map(
      (label) => `PO #${label}`
    ),
    cardHeading: "Approver Response Time",
    chartLabels: ["Average Response Time", "Minimum Response Time"],
    barColors: ["#F8E4AC", "#6199B3"],
    chartIndicators: [
      {
        value: "Response Time in Hours (RTH)",
        color: "#F8E4AC",
      },
      {
        value: "Response Time in Minutes (RTM)",
        color: "#6199B3",
      },
    ],
  };

  const pendingAndClosedRFQDataValues = analyticsData?.pendingVsCloseRFQ || [
    0, 0,
  ];


  //  cardHeading, chartIndicators, progressLines, barColors, chartLabels, chartText
  const pendingAndClosedRFQDataSets = {
    cardHeading: "Pending and Closed RFQ",
    chartText: (
      <span>
        Total RFQ <br />{" "}
        {pendingAndClosedRFQDataValues[0] + pendingAndClosedRFQDataValues[1]}
        {/* {analyticsData?.totalRFQCreatedValueMonthWise?.length > 1 &&
          analyticsData?.totalRFQCreatedValue?.reduce((a, b) => a + b)} */}
      </span>
    ),
    chartLabels: ["Pending RFQ", "Closed RFQ"],
    barColors: ["#EF737F", "#52497C"],
    chartIndicators: [
      {
        value: "Pending",
        color: "#EF737F",
      },
      {
        value: "Closed",
        color: "#52497C",
      },
    ],
    progressLines: [
      {
        label: `Pending RFQ - ${pendingAndClosedRFQDataValues[0] || 0}`,
        color: "#EF737F",
        value: pendingAndClosedRFQDataValues[0] || 0,
      },
      {
        label: `Closed RFQ - ${pendingAndClosedRFQDataValues[1] || 0}`,
        color: "#52497C",
        value: pendingAndClosedRFQDataValues[1] || 0,
      },
    ],
  };

  const purchaseOrderData = analyticsData?.purchaseOrderStatus || [
    0, 0, 0,
  ];


  //  cardHeading, chartIndicators, progressLines, barColors, chartLabels, chartText
  const purchaseOrderDataSets = {
    cardHeading: "Pending and Approved PO",
    chartText: (
      <span>
        Total PO <br />{" "}
        {purchaseOrderData[0] + purchaseOrderData[1] + purchaseOrderData[2] + purchaseOrderData[3]}
        {/* {analyticsData?.totalRFQCreatedValueMonthWise?.length > 1 &&
          analyticsData?.totalRFQCreatedValue?.reduce((a, b) => a + b)} */}
      </span>
    ),
    chartLabels: ["Pending PO", "Approved PO", "Rejected PO", "Cancelled PO"],
    barColors: ["#4ac6b7", "#4f5e7f", "#965f8a", "#ff7070"],
    chartIndicators: [
      {
        value: "Pending",
        color: "#4ac6b7",
      },
      {
        value: "Approved",
        color: "#4f5e7f",
      },
      {
        value: "Rejected",
        color: "#965f8a",
      },
      {
        value: "Cancelled",
        color: "#ff7070",
      },
    ],
    progressLines: [
      {
        label: `Pending PO - ${purchaseOrderData[0] || 0}`,
        color: "#4ac6b7",
        value: purchaseOrderData[0] || 0,
      },
      {
        label: `Approved PO - ${purchaseOrderData[1] || 0}`,
        color: "#4f5e7f",
        value: purchaseOrderData[1] || 0,
      },
      {
        label: `Rejected PO - ${purchaseOrderData[2] || 0}`,
        color: "#965f8a",
        value: purchaseOrderData[2] || 0,
      },
      {
        label: `Cancelled PO - ${purchaseOrderData[3] || 0}`,
        color: "#ff7070",
        value: purchaseOrderData[3] || 0,
      },
    ],
  };

  //report card data
  const reportCardData = [
    {
      cardName: "Total PO Value",
      cardImg: totalPOIMg,
      cardValue: `Rs.${analyticsData?.totalPOValue}`,
    },
    {
      cardName: "First time Purchase Cost Savings V1",
      cardImg: totalPOIMg3,
      cardValue: `Rs.${analyticsData?.costSavingsMetric1.toLocaleString()}`,
    },
    {
      cardName: "First time Purchase Cost Savings V2",
      cardImg: totalPOIMg,
      cardValue: `Rs.${analyticsData?.costSavingsMetric2.toLocaleString()}`,
    },
    {
      cardName: "Repeat Purchase Cost Savings",
      cardImg: totalPOIMg2,
      cardValue: `Rs.${analyticsData?.repeatPurchaseCostSavings.toLocaleString()}`,
    },
  ];
  // chart option handling
  const handleChooseRFQDuration = (option) => {
    setRFQCreationOption(option)
  }
  const handleChoosePODuration = (option) => {
    setTotalPOOption(option)
  }
  return (
    <div className={`${classes.dashboard_tab_wrapper}`}>
      <div className={`${classes.topHeader}`}>
        <HeaderTitle titleText={data.access_type == "User" ? "PO Dashboard" : "Buyer Dashboard"} />

        {/* <div className={`${classes.notificationBar}`}>
          <DateBar />
          <NotificationBell />
          <ProfileCard
            imageSrc={profileImg}
            buyerBtn={true}
            buyerBtnOutline={true}
            profilePath={"/Buyer_dashboard/My_profile"}
          />
        </div> */}
      </div>

      <div className={`${classes.heading_inputs}`}>
        <div className={`${classes.filters} ${classes.flex}`}>
          {data.access_type == "Buyer" &&
            <>
              <DSelectInput
                options={vendorList.values}
                getIDValue={true}
                customClass={classes.filterFields}
                label={"Vendor Company Name"}
                setIDValue={(e) => {
                  setVendorDetails((prev) => ({
                    ...prev,
                    vendorID: e,
                  }));
                  getvendorName(e) // get customer details
                }}
                onChange={(e) => {
                  console.log(e)
                  setVendorDetails((prev) => ({
                    ...prev,
                    vendorName: e,
                  }));
                }}
              />

              <DSelectInput
                id="vendorName"
                options={vendornameList.values}
                getIDValue={true}
                customClass={classes.filterFields}
                label={"Vendor Name"}
                disabled={!vendorDetails?.vendorID || vendorDetails?.vendorID?.length === 0}
                setIDValue={(e) => {
                  setVendorNameDetails((prev) => ({
                    ...prev,
                    buyerID: e,
                  }));
                }}
                onChange={(e) => {
                  setVendorNameDetails((prev) => ({
                    ...prev,
                    buyerName: e,
                  }));
                }}
              />

              <DSelectInput
                options={itemList.values}
                customClass={classes.filterFields}
                getIDValue={true}
                label={"Item Name"}
                setIDValue={(e) => {
                  setItemCode((prev) => ({
                    ...prev,
                    item_token: e,
                  }));
                }}
                onChange={(e) => {
                  setItemCode((prev) => ({
                    ...prev,
                    item_code: e,
                  }));
                }}
              />
            </>
          }
          <DSelectInput
            options={durationList}
            customClass={classes.filterFields}
            label={"Duration"}
            onChange={(e) => {
              setDuration(e);
              setFromDate({
                value: "",
                isValid: true,
              });
              setToDate({
                value: "",
                isValid: true,
              });
            }}
          />

          <DDateInput
            customClass={classes.filterFields}
            type={"date"}
            label={"From Date"}
            disableFuture={true}
            onChange={(e) => {
              setFromDate({
                isValid: emptyCheck(e),
                value: e,
              });
            }}
            disabledInput={duration}
            value={fromDate}
            error={!fromDate?.isValid}
            errorMsg={"From date is required"}
          />

          <div className={`${classes.flex} ${classes.filterSearch}`}>
            <DDateInput
              customClass={classes.filterFields}
              type={"date"}
              label={"To Date"}
              disableFuture={true}
              onChange={(e) => {
                setToDate({
                  isValid: emptyCheck(e),
                  value: e,
                });
              }}
              disabledInput={duration}
              value={toDate}
              error={!toDate?.isValid}
              errorMsg={"To date is required"}
            />

            <DButton
              buyerBtn={true}
              labelImg={btnImg}
              customWrapperClass={classes.filterBtn}
              customClass={classes.button}
              iconWidth={"2rem"}
              iconHeight={"2rem"}
              onClick={handleFilterSearch}
            />
          </div>
        </div>
      </div>

      <div className={classes.mainContent}>

        <div className={classes.reports}>
          {reportCardData?.map((e, i) => (
            <Reportcard
              key={i}
              title={e.cardName}
              value={e.cardValue}
              reportImg={e.cardImg}
              customClass={classes.reportCard}
              loadingState={loadingState}
            />
          ))}
        </div>

        <div className={classes.metrics}>

          <div className={classes.topFour}>

            {data.access_type == "User" &&
              <DonutChart
                chartValues={purchaseOrderData}
                customCardClass={classes.chartfirstRow}
                chartDataSet={purchaseOrderDataSets}
                loadingState={loadingState}
              />
            }

            {data.access_type == "Buyer" &&
              <>
                <DonutChart
                  chartValues={pendingAndClosedRFQDataValues}
                  customCardClass={classes.chartfirstRow}
                  chartDataSet={pendingAndClosedRFQDataSets}
                  loadingState={loadingState}
                />

                <DonutChart
                  chartValues={submittedAndSelectedDataValue}
                  customCardClass={classes.chartfirstRow}
                  chartDataSet={submittedAndSelectedDataSets}
                  loadingState={loadingState}
                />

                <DonutChart
                  chartValues={openCancelPendingDataValue}
                  customCardClass={classes.chartSecondRow}
                  chartDataSet={openCancelPendingDataSets}
                  loadingState={loadingState}
                />

              </>
            }
            {data.access_type == "Buyer" &&
              <LineChart
                dataLabel={RFQCreatedDataLabel}
                dataValues={RFQCreatedDataValues}
                chartDataSet={RFQCreatedDataSets}
                customCardClass={classes.ChartSecondRow}
                loadingState={loadingState}
                durationValue={RFQCreationOption}
                chooseChartDuration={handleChooseRFQDuration}
                disableDuration={false}
              />
            }

            <LineChart
              dataLabel={totalPODataValuesLabel}
              dataValues={totalPODataValues}
              chartDataSet={totalPODataSets}
              vendorChart={true}
              customCardClass={classes.ChartSecondRow}
              loadingState={loadingState}
              durationValue={totalPOOption}
              chooseChartDuration={handleChoosePODuration}
              disableDuration={false}
            />
          </div>

          <div style={{ width: '100%' }}>
            <HeaderTitle titleText={"Total Spend By Items"} />

            <div className={classes.search_add_wrapper}>
              <SearchBar
                onChange={(query) => {
                  setSearchQuery(query);
                  setPageNumber(1);
                }}
              />
            </div>

            <div style={{ width: '100%' }}>
              <DataTable
                headings={headings}
                tableData={spendItems}
                actions={false}
                tableSize={spendItems?.length === 0 ? "100%" : "100vw"}
                viewBtn={false}
                deleteBtn={false}
                editBtn={false}
                sorting={true}
                errorMessage={tableProps.errorMessage}
                isLoading={tableProps.isLoading}
                itemsTable={true}
                setSortingColumnName={setSortingColumnName}
                sortingColumnName={sortingColumnName}
                setSortingOrder={setSortingOrder}
                sortingOrder={sortingOrder}
              />

              <PaginationComponent
                pageNumber={pageNumber}
                currentPage={currentPage || 0}
                itemsPerPage={itemsPerPage || 0}
                totalItems={totalItems || 0}
                setPageNumber={setPageNumber}
                previouPageClick={() => {
                  previouPageClick(pageNumber, setPageNumber);
                }}
                nextPageClick={() => {
                  nextPageClick(pageNumber, setPageNumber, paginationData);
                }}
                disablePrevious={parseInt(pageNumber) === 1 || pageNumber === ""}
                disableNext={
                  parseInt(pageNumber) === paginationData?.page_count ||
                  !paginationData ||
                  pageNumber === ""
                }
              />
            </div>
          </div>



          <BarChart
            mainData={totalSpentDataValue?.values}
            labels={totalSpentDataValue?.labels}
            customCardClass={classes.chartThirdRow}
            chartDataSet={totalSpentDataSetDataSets}
            loadingState={loadingState}
          />



          {data.access_type == "Buyer" &&
            <HorizontalBarChart
              chartData={vendorResponseTimeDataSet.chartData}
              customCardClass={classes.chartFourthRow}
              chartDataSet={vendorResponseTimeDataSet}
              loadingState={loadingState}
            />
          }
          {data.access_type == "User" &&
            <HorizontalBarChart
              chartData={approverResponseTimeDataSet.chartData}
              customCardClass={classes.chartFourthRow}
              chartDataSet={approverResponseTimeDataSet}
              loadingState={loadingState}
              approveData={true}
            />
          }
        </div>
      </div>


      {/* <div className={classes.mainContent}>
        <GstFilingTable />
      </div> */}


      <div className={classes.mainContent}>
        <MerchantInvoiceDelay />
      </div>







    </div>
  );
};

export default BuyerDashboardTab;
